import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGridIcon, ShieldIcon, RefreshCwIcon, ScaleIcon, ServerIcon, TrendingUpIcon } from 'lucide-react';
import { competencies, type Competency } from '../data/profile';
import { SectionHeading } from './SectionHeading';
const iconMap: Record<Competency['icon'], React.ElementType> = {
  governance: LayoutGridIcon,
  command: ShieldIcon,
  transformation: RefreshCwIcon,
  compliance: ScaleIcon,
  technology: ServerIcon,
  operations: TrendingUpIcon
};
export function Competencies() {
  return <section id="expertise" className="w-full scroll-mt-20 bg-canvas py-20 lg:py-28" aria-labelledby="expertise-heading" data-id="element-29" data-mp="2t0lg4r1xb25b">
      <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-30" data-mp="31zgrehjtr2fh">
        <SectionHeading id="expertise-heading" eyebrow="Section 02 · Core Competencies" title="Executive Expertise & Capabilities" data-id="element-31" data-mp="13jkfjuwzedls" />

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-32" data-mp="17lfsxxs6shfx">
          {competencies.map((item, i) => {
          const Icon = iconMap[item.icon];
          return <motion.article key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.3
          }} transition={{
            duration: 0.45,
            delay: i % 3 * 0.08
          }} className="group relative bg-white p-8 transition-colors duration-300 hover:bg-navy" data-id="element-33" data-mp="2dkenad91xurf" data-mpi={i}>
                <span className="absolute left-0 top-0 h-[3px] w-0 bg-gold transition-all duration-300 group-hover:w-full" aria-hidden="true" data-id="element-34" data-mp="2wawak2b47y5e" />
                <span className="flex h-12 w-12 items-center justify-center border border-navy/15 bg-canvas transition-colors duration-300 group-hover:border-gold/50 group-hover:bg-navy-steel" data-id="element-35" data-mp="1kwsbihpo7jth">
                  <Icon className="h-5 w-5 text-navy-steel transition-colors duration-300 group-hover:text-gold" aria-hidden="true" data-id="element-36" data-mp="7x785gr2vtf2" />
                </span>
                <h3 className="mt-6 font-display text-lg font-bold leading-snug text-navy transition-colors duration-300 group-hover:text-white" data-id="element-37" data-mp="3u5q9vxt465s6">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-navy-steel/85 transition-colors duration-300 group-hover:text-white/75" data-id="element-38" data-mp="3kevlonwb4w43">
                  {item.description}
                </p>
                <p className="mt-6 font-display text-[10px] font-bold uppercase tracking-[0.24em] text-navy/30 transition-colors duration-300 group-hover:text-gold" data-id="element-39" data-mp="3bf8ko37hpsbk">
                  {String(i + 1).padStart(2, '0')}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}